// extracted by mini-css-extract-plugin
export default {"instructions":"Instructions_instructions__hQ6OL"};